import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { useMarket } from '@/contexts/market-context/market-context'
import { AnalyticsEvent } from '@/types'

import { useOptionalUser } from './use-user'

export interface UseAnalytics {
  sendEvent(event: AnalyticsEvent): Promise<void>
  sendCustomEvent: (event: SendCustomEventProps) => Promise<void>
}

interface SendCustomEventProps {
  event_label: string
  event_action: string
  customInfo?: CustomInfo
  event?: AnalyticsEvent
}

export interface CustomInfo {
  [key: string]: any
}

export const useAnalytics = (): UseAnalytics => {
  const { isPreview } = useRouter()
  const { language_code: site_language } = useMarket()
  const { user } = useOptionalUser()

  const sendEvent = useCallback(
    async (inputEvent: AnalyticsEvent) => {
      if (
        !isPreview &&
        window?.sendEvent &&
        typeof window.sendEvent === 'function'
      ) {
        window.sendEvent({
          ...inputEvent,
          event_category: 'circular_hub',
          custom: {
            ...(inputEvent?.custom || {}),
            site_language: site_language,
            logged_in: Boolean(user),
          },
        })
      }
    },
    [isPreview, site_language, user]
  )

  const sendCustomEvent = useCallback(
    ({ event_label, event_action, customInfo, event }: SendCustomEventProps) =>
      sendEvent({
        event_action,
        event_label,
        custom: {
          ...(customInfo && { ...customInfo }),
          ...(event?.custom || {}),
        },
        ...(event || {}),
      }),
    [sendEvent]
  )

  return {
    sendEvent,
    sendCustomEvent,
  }
}
